 <div (@valDropDownAnimation.done)="animationDone($event)" [@valDropDownAnimation]="animationState" @valDropDownVoidAnimation
    [class]="'dropdown-menu val-dropdown-menu show py-0 mt-1' + (class?' ' + class:'')">
    <ng-container #vc></ng-container>
</div>